const INACCESSIBLE_ITEM = 'Inaccessible';
export default INACCESSIBLE_ITEM;
